// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2d73J","content":"RecentSearches_content__2nno_"};